/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Card, CardHeader, CardContent, CardActions, Typography } from '@material-ui/core'

import SMAvatar from '../../Results/components/Avatars/SMAvatar';

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({
    
})

class TicketCard extends Component {
    state = {
        variant : "outlined",
        selected : false
    }

    componentWillMount () {
        if (this.props.selected_id === this.props.ticket[this.props.config.fields.find(field => field.type === "id").raw_field_name]) {
            this.setState({
                variant : "elevated",
                selected : true
            })
        }
    }

    // componentWillUpdate () {
    //     if (this.props.selected_id === this.props.ticket.number) {
    //         this.setState({
    //             variant : "elevated",
    //             selected : true
    //         })
    //     }
    // }

    toggleVariant = () => {
        if (this.state.selected === false) {
            this.setState({
                ...this.state,
                variant : this.state.variant === "outlined" ? "elevated" : "outlined"
            })
        }
    }

    selectTicket = () => {
        console.log("Selecting Ticket : ", this.props.ticket[this.props.config.fields.find(field => field.type === "id").raw_field_name])
        this.props.select_ticket(this.props.ticket[this.props.config.fields.find(field => field.type === "id").raw_field_name])
    }

    getVariant = () => {
        if (this.props.selected_id === this.props.ticket[this.props.config.fields.find(field => field.type === "id").raw_field_name]) {
            return "elevated"
        } else {
            return "outlined"
        }
    }

    render() {
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <Card 
                    key = {this.props.ticket[this.props.config.fields.find(field => field.type === "id").raw_field_name]} 
                    style = {{
                        width : '100%', 
                        marginBottom : '10px', 
                        cursor : 'pointer', 
                        backgroundColor : this.getVariant() === "outlined" ? '#F4F4F4' : '#FFFFFF'
                    }} 
                    variant = {this.getVariant()} 
                    square 
                    // onMouseEnter = {this.toggleVariant}
                    // onMouseLeave = {this.toggleVariant}
                    onClick = {this.selectTicket}
                    elevation = {5}
                >
                    <CardHeader
                        avatar = {<SMAvatar disabled = {false}/>}
                        subheader = {this.props.config.fields.find(field => field.type === "id").name}
                        title = {this.props.ticket[this.props.config.fields.find(field => field.type === "id").raw_field_name]}
                        titleTypographyProps = {{
                            style : {
                                fontWeight: 'bold'
                            },
                            color: 'primary'
                        }}
                        subheaderTypographyProps = {{
                            color: 'textSecondary',
                            tabIndex : 0
                        }}
                    />
                    <CardContent>
                        <Typography variant = 'overline' color = 'primary'>{this.props.config.fields.find(field => field.type === "title").name}</Typography>
                        <Typography variant = 'body2' dangerouslySetInnerHTML = {{__html : this.props.ticket[this.props.config.fields.find(field => field.type === "title").raw_field_name]}}></Typography>
                    </CardContent>
                </Card>
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(TicketCard);